import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Row, Col, Drawer, Divider } from 'antd';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { isMobile } from 'react-device-detect';
import { _newLine } from '@/utils/helpers';
import { createPrescriptionTemplate, updatePrescriptionTemplate } from '@/redux/actions/prescriptionTemplateActions';

class PrescriptionTemplateForm extends Component {
    constructor() {
        super();
        this.state = {
            loadingForm: false,
        };
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({ loadingForm: true })
                    console.log('values: ', values)

                    if (this.props.currentItem) {
                        await this.props.updatePrescriptionTemplate(this.props.currentItem.id, values);
                        this.onClose();
                    } else {
                        await this.props.createPrescriptionTemplate(values);
                        this.onClose();
                    }
                    this.props.reloadData();
                } catch (error) {
                    this.setState({ loadingForm: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({
            loadingForm: false
        })
    }

    render() {
        var { loadingForm } = this.state;
        var { visible, currentItem } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentItem ? "Sửa mẫu đơn thuốc" : "Thêm mẫu đơn thuốc"}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.onClose()}>
                            Huỷ
                        </Button>
                        <Divider type="vertical" />
                        <Button loading={loadingForm} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentItem ? "Cập nhật" : "Thêm mới"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Tên đơn thuốc">
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.name : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Nội dung">
                                    {getFieldDecorator('content', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.content) : null
                                    })(
                                        <Input.TextArea rows={20} placeholder="Nhập nội dung" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.status : 1
                                    })(
                                        <BaseRadioList
                                            options={[
                                                { label: "Active", value: 1 },
                                                { label: "Inactive", value: 0 }
                                            ]}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        createPrescriptionTemplate: (data) => dispatch(createPrescriptionTemplate(data)),
        updatePrescriptionTemplate: (id, data) => dispatch(updatePrescriptionTemplate(id, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'PrescriptionTemplateForm' })(PrescriptionTemplateForm));
